module.exports = __webpack_public_path__ + "img/title.d49039aa.png";